import Player from 'video.js/dist/types/player';

export function getVideoJSConfig(
  overrideNativeHls: boolean
): Partial<Player['options_']> {
  return {
    //sources: [{ src: 'https://test-streams.mux.dev/x36xhzz/x36xhzz.m3u8' }],
    fluid: true,
    fill: true,
    controls: true,
    techOrder: ['chromecast', 'html5'],
    html5: {
      vhs: {
        overrideNative: overrideNativeHls,
      },
      nativeAudioTracks: false,
      nativeVideoTracks: false,
      nativeTextTracks: false,
    },
    //textTrackSettings: false,
    liveui: true,
    responsive: true,
    controlBar: {
      // #TODO: remove skip buttons when playing preroll
      /*skipButtons: {
        forward: 10,
        backward: 10,
      },*/
      children: [
        'playToggle',
        //'skipBackward',
        //'skipForward',
        'volumePanel',
        'currentTimeDisplay',
        'timeDivider',
        'durationDisplay',
        'progressControl',
        'liveDisplay',
        'seekToLive',
        'customControlSpacer',
        'playbackRateMenuButton',
        /*"chaptersButton",
        "descriptionsButton",
        "subsCapsButton",
        "audioTrackButton",*/
        'fullscreenToggle',
      ].filter((x) => x !== undefined),
      volumePanel: {
        inline: false,
      },
    },
  } as Partial<Player['options_']>;
}
